// default navicon
export function navicon() {
    // document.querySelector('.site-navigation__navicon').addEventListener('click', (e) => {
    //     e.preventDefault();
    //     e.currentTarget.classList.toggle('site-navigation__navicon--active');
    //     document.querySelector('.site-navigation').classList.toggle('site-navigation--active');
    //     document.body.classList.toggle('site-navigation--open');
    // });

    const navGroup = document.querySelector('.site-navigation__group');
    const nav = document.querySelector('.site-navigation');
    const navicon = document.querySelector('.site-navigation__navicon');

    navGroup.addEventListener('click', (e) => {
        e.preventDefault();
        navGroup.classList.toggle('site-navigation__group--active');
        nav.classList.toggle('site-navigation--active');
        document.body.classList.toggle('site-navigation--open');

        navicon.classList.toggle('site-navigation__navicon--active');
        document.body.classList.toggle('site-navigation__navicon--open');

        const menuTxt = document.querySelector('.site-navigation__group--menu');
        setTimeout(() => {
            menuTxt.innerHTML = menuTxt.innerHTML === "Close" ? "Menu" : "Close";
        }, 300);
    });

}

document.addEventListener('DOMContentLoaded', () => {


});